const samsung = 'https://samsung.com';

// const samsungwebsites = {
//     KSA_EN: `${samsung}/sa_en/`,
//     KSA_AR: `${samsung}/sa_ar/`,
//     JO_EN: `${samsung}/levant_en/`,
//     JO_AR: `${samsung}/levant/`,
//     IQ_AR: `${samsung}/iq_ar/`,
//     LB_EN: `${samsung}/lb/`,
//     MO_FR: `${samsung}/n_africa/`,
//     PK_EN: `${samsung}/pk/`,
//     EG_EN: `${samsung}/eg/`,
//     EG_AR: `${samsung}/eg/`,
//     IL_HE: `${samsung}/il/`,
// }

const websitesList = [
    { id: 1, name: 'KSA - EN', value: `${samsung}/sa_en/`},
    { id: 2, name: 'KSA - AR', value: `${samsung}/sa_ar/`},
    { id: 3, name: 'JORDON - EN', value: `${samsung}/levant_en/`},
    { id: 4, name: 'JORDON - AR', value: `${samsung}/levant/`},
    { id: 5, name: 'IRAQ - AR', value: `${samsung}/iq_ar/`},
    { id: 6, name: 'LEBANON - EN', value: `${samsung}/lb/`},
    { id: 7, name: 'MOROCCO - FR', value: `${samsung}/n_africa/`},
    { id: 8, name: 'PAKISTAN - EN', value: `${samsung}/pk/`},
    { id: 9, name: 'EGYPT - EN', value: `${samsung}/eg/`},
    { id: 10, name: 'EGYPT - AR', value: `${samsung}/eg/`},
    { id: 11, name: 'ISRAEL - HE', value: `${samsung}/il/`},
]

export default websitesList;